/*!
 * rkc-performance.js
 * Light INP optimization for RoyalKadoo
 */
(function() {
  if (document.documentElement.classList.contains('rkc-performance-loaded')) return;
  document.documentElement.classList.add('rkc-performance-loaded');

  // 1) Make some listeners passive to reduce blocking
  try {
    var origAdd = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      try {
        if (
          (type === 'touchstart' || type === 'touchmove' || type === 'wheel') &&
          (typeof options === 'object' || options === undefined)
        ) {
          if (typeof options === 'object') {
            if (options.passive == null) {
              options = Object.assign({}, options, { passive: true });
            }
          } else {
            options = { passive: true };
          }
        }
      } catch (e) {}
      return origAdd.call(this, type, listener, options);
    };
  } catch (e) {
    // ignore
  }

  // 2) Simple lazy image optimization (snippets/rkc-lazy-images.liquid)
  function upgradeLazy() {
    var imgs = document.querySelectorAll('img.rkc-lazy-image[data-src]');
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(loadImg);
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadImg(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
    imgs.forEach(function(img) { io.observe(img); });
  }

  function loadImg(img) {
    var src = img.getAttribute('data-src');
    if (!src) return;
    img.src = src;
    img.removeAttribute('data-src');
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    upgradeLazy();
  } else {
    document.addEventListener('DOMContentLoaded', upgradeLazy);
  }

  // 3) Reduce reflows by batching common changes
  var pending = [];
  function schedule(fn) {
    pending.push(fn);
    if (pending.length === 1) {
      requestAnimationFrame(function() {
        var tasks = pending.slice();
        pending.length = 0;
        tasks.forEach(function(t) {
          try { t(); } catch(e) {}
        });
      });
    }
  }

  // Example: class toggle helper for custom scripts
  window.RoyalKadooPerf = window.RoyalKadooPerf || {};
  window.RoyalKadooPerf.toggleClass = function(el, cls, force) {
    if (!el) return;
    schedule(function() {
      if (typeof force === 'boolean') {
        el.classList.toggle(cls, force);
      } else {
        el.classList.toggle(cls);
      }
    });
  };

  // ===== Image + iframe loading optimizations (DOM/Network) =====
  function optimizeMedia(){
    try{
      var main = document.querySelector('main') || document.body;
      if(!main) return;

      // 1) Mark the likely LCP image eager/high priority (first large image in main)
      var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
      var lcpSet = false;
      imgs.forEach(function(img){
        if(!img || img.dataset && (img.dataset.src || img.dataset.srcset)) return; // keep lazy libs
        if(!img.getAttribute('decoding')) img.setAttribute('decoding','async');

        // set loading lazily for offscreen images
        if(!img.getAttribute('loading')){
          try{
            var r = img.getBoundingClientRect();
            if(r && r.top > 900){
              img.setAttribute('loading','lazy');
            }
          }catch(e){}
        }

        if(!lcpSet){
          try{
            var r2 = img.getBoundingClientRect();
            // choose first reasonably big above-the-fold image
            if(r2 && r2.top >= -50 && r2.top < 650 && r2.width >= 320 && r2.height >= 180){
              img.setAttribute('loading','eager');
              // fetchpriority supported in modern browsers
              img.setAttribute('fetchpriority','high');
              lcpSet = true;
            }
          }catch(e){}
        }
      });

      // 2) Lazy-load iframes/videos below the fold
      var iframes = Array.prototype.slice.call(main.querySelectorAll('iframe'));
      iframes.forEach(function(fr){
        if(!fr.getAttribute('loading')) fr.setAttribute('loading','lazy');
        if(!fr.getAttribute('decoding')) fr.setAttribute('decoding','async');
      });

      var videos = Array.prototype.slice.call(main.querySelectorAll('video'));
      videos.forEach(function(v){
        // prevent heavy downloads before interaction
        if(!v.getAttribute('preload')) v.setAttribute('preload','metadata');
      });
    }catch(e){}
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', optimizeMedia, { once: true });
  }else{
    optimizeMedia();
  }

})();